import React, {useEffect, useState} from 'react';
import {Collection} from "types/Collection";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import {useOperator} from "../../../context/OperatorContext";

// Types ----

type DeleteCollectionProps = {
  collection: Collection | null
  show: boolean
  onDelete?: (collection: Collection) => any
  onDeleteFail?: (collection: Collection, error: unknown) => any
  onCancel?: () => any
}

function DeleteCollection({collection, onCancel, onDelete, onDeleteFail, show}: DeleteCollectionProps) {
  const {termFor} = useOperator();

  const [name, setName] = useState<string>(collection?.name || 'this collection');
  const {mutateAsync: deleteCollection} = useMutation(ngage.collections.destroy)

  useEffect(() => {
    if (collection) setName(collection.name)
  }, [collection]);

  async function handleDeleteCollection() {
    if (collection) {
      try {
        await deleteCollection(collection.id)
        await invalidate('collections.all')

        if (onDelete) onDelete(collection)
      } catch (error) {
        if (onDeleteFail) onDeleteFail(collection, error)
      }
    }
  }

  function handleCancel() {
    if (onCancel) onCancel()
  }

  return (
    <ConfirmModal
      show={show}
      type={ConfirmModal.types.DANGER}
      title={`Delete ${termFor('Collection')}`}
      body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
      approveLabel="Delete"
      onApprove={handleDeleteCollection}
      onCancel={handleCancel}
    />
  );
}

export default DeleteCollection;